

import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Col, Row } from 'reactstrap'
import AppBar from '../../components/AppBar'
import Preview from '../../components/Preview'
import Register from '../../components/Register'
import { setPreviewImage } from '../../redux/slices/userSlice'
import { getByUserImg } from '../../service/fileUtils'
import { getUserId } from '../../auth'
import { useQuery } from '@apollo/client'
import { GET_BY_USER_ID } from '../../gql/user'
import LoadinSpinner from '../../components/LoadinSpinner'
import { getCookieString } from '../../utils/cookies'

function Home() {

  const userRedux = useSelector((state) => state);
  const [user, setUser] = useState({})
  const dispatch = useDispatch()
  const resolvedUserId = getUserId()
  const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
  const validUserId = resolvedUserId && uuidRegex.test(resolvedUserId) ? resolvedUserId : null
  const { data, loading, error } = useQuery(GET_BY_USER_ID, {
    skip: !validUserId,
    variables: { id: validUserId },
    fetchPolicy: 'no-cache'
  })

  useEffect(() => {
    if (data) {
      switch (userRedux.typeLanguage) {
        case "pt":
          if (Object.keys(data.employees).length > 0)
            setUser(data.employees[0])
          break;
        case "en":
          if (Object.keys(data.employees_en).length > 0) {
            setUser(data.employees_en[0])
          } else {
            setUser({ ...data.employees[0], language: "en" })
          }
          break;
        case "es":
          if (Object.keys(data.employees_es).length > 0) {
            setUser(data.employees_es[0])
          } else {
            setUser({ ...data.employees[0], language: "es" })
          }
          break;
        default:
          if (Object.keys(data.employees).length > 0)
            setUser(data.employees[0])
      }
      if (data.employees.length > 0) {
        getByUserImg(data.employees[0].image).then(response => {
          dispatch(setPreviewImage(URL.createObjectURL(response.data)))
        }).catch(error => {
          console.error('[home] Erro ao carregar imagem do usuário', error)
        })

      }
    }
  // dispatch não incluído intencionalmente; somente leitura aqui
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, userRedux.typeLanguage])
  if (!validUserId) {
    return <div style={{padding: 40}}>
      <h4>Sem usuário autenticado</h4>
      <p>Não foi possível resolver um ID de usuário válido. Certifique-se de que o backend definiu o cookie 'employee_id' (ou 'base64Id') e que ele é um UUID.</p>
    </div>
  }

  if (loading) return <>
    <div style={{
      background: 'rgb(53 66 194 / 15%)',
      width: "100vw",
      height: "100vh"
    }} className='d-flex justify-content-center align-items-center'>
      <LoadinSpinner color='black'
        height="75"
        width="75"
      />
    </div>

  </>;
  if (error) return <div>Error! {error.message}</div>;


  return (
    <>
      <AppBar />
      <Row style={{ margin: "0", height: "94vh" }}>
        <Col md={6} style={{ margin: "0", padding: "0", backgroundColor: "#F2F2F2" }}>
          <Register userInfo={user} />
        </Col>
        <Col md={6} style={{ margin: "0", padding: "0" }}>
          <Preview userInfo={user} />
        </Col>
      </Row>
    </>
  )
}

export default Home